<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >{{ data.editar ? "Editar" : "Nuevo" }} cliente</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formCliente" autocomplete="off">
            <mat-form-field class="full-width" *ngIf="!data.editar">
                <mat-label>Rut </mat-label>
                <input matInput type="text" formControlName="rut" required />
                <mat-hint>Rut con formato 12345678-9</mat-hint>
                <mat-error *ngIf="rut.hasError('required')">
                    Debe ingresar el rut del cliente
                </mat-error>
                <mat-error *ngIf="rut.hasError('digitoVerificador')">
                    Debe ingresar un rut válido
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Razón social </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="razonSocial"
                    required
                />

                <mat-error *ngIf="razonSocial.hasError('required')">
                    Debe ingresar la razón social del cliente
                </mat-error>
                <mat-error *ngIf="razonSocial.hasError('minlength')">
                    La razón social del cliente debe tener al menos 3 caracteres
                </mat-error>
                <mat-error *ngIf="razonSocial.hasError('maxlength')">
                    La razón social del cliente no puede ser mayor a 100
                    carcateres
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formCliente.value"
            [disabled]="!formCliente.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
